import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si doy hidrología en primaria?',
    a: 'Sí. El material está adaptado para primaria y secundaria con actividades diferenciadas por nivel. El Tomo 1 empieza desde los fundamentos absolutos y los bonos incluyen actividades específicas para cada ciclo, con lenguaje accesible y recursos visuales.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. Los PDFs son de alta calidad y están optimizados para leer en pantalla o imprimir.'
  }, {
    q: '¿El Nivel Avanzado es necesario?',
    a: 'Depende de tu objetivo. Si enseñás en primaria o en el ciclo básico del secundario, el Megapack base es más que suficiente para todo el año. Si trabajás en 5to o 6to año, en el profesorado o querés preparar proyectos para ferias de ciencias nacionales, el Nivel Avanzado es la mejor inversión.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día ya podés usar las actividades del Bono 1 y los diagramas del Tomo 1. La mayoría de docentes implementa cambios visibles en la primera semana de clases.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a packcentral23@gmail.com dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.'
  }, {
    q: '¿Aplica para cualquier provincia argentina?',
    a: 'Sí. Todo el contenido usa ejemplos de ríos, cuencas, acuíferos y casos de contaminación de todas las regiones del país. Mendoza, Corrientes, Misiones, Buenos Aires, Chaco, Patagonia. Hay material relevante para docentes de cualquier provincia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#0a1428]" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-49">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-500/30 rounded-2xl overflow-hidden bg-[#0f1d35]/60" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 hover:bg-[#1e3a5f]/40 transition-colors" aria-expanded={openIndex === i} data-id="element-53">
                <span className="font-bold text-white pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-slate-500/30 pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}